export type DistrictId = string;

export enum DataSource {
  AWBD = 'AWBD',
  TCEQ = 'TCEQ'
}

export type Address = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
};

export type Affiliation = {
  organization: string;
  address: Partial<Address>;
  phone: string;
};

type NullableDistrictProps = {
  districtType: string;
  acreage: number;
  address: Partial<Address>;
  phone: string;
  website: string;
  dateEstablished: Date;
  bondsOutstanding: number;
  assessedValue: number;
  waterConnections: number;
  sanitaryConnections: number;
};

type RequiredDistrictProps = {
  districtId: DistrictId;
  name: string;
  county: string;
  isMember: boolean;
  geoBounds: [number, number, number, number];
  dataSource: DataSource;
  operators: Affiliation[];
  attorneys: Affiliation[];
  bookKeepers: Affiliation[];
  assessors: Affiliation[];
};

/** Comprehensive district with properties required for district details */
export type District = RequiredDistrictProps & Partial<NullableDistrictProps>;

/** Abbreviated district with properties required for listing in filter results */
export type DistrictListing = Pick<
  District,
  | 'districtId'
  | 'districtType'
  | 'name'
  | 'isMember'
  | 'acreage'
  | 'dateEstablished'
  | 'bondsOutstanding'
  | 'assessedValue'
  | 'waterConnections'
  | 'sanitaryConnections'
>;
